<template>
    <div class='fortuna_casino text-center'>
        <h6 class="text-center">{{'lucky_numbers' | lang}}</h6>
        <div class="lucky-symbols w-100 d-flex align-items-center justify-content-center">
            <div v-for="(symbol, itemIndex) in luckySymbols" :key="itemIndex" :class="{'symbol d-flex align-items-center justify-content-center':true, 'lucky':luckySymbolsArray.includes(symbol)}">
                <span class="amount">{{symbol}}</span>
            </div>
        </div>
        <div>
            <div>
                <h6 class="text-center pt-3">{{'your_numbers' | lang}}</h6>
                <div class="your-symbols w-100 d-flex align-items-center justify-content-center flex-column">
                    <div v-for="(row, rowIndex) in yourSymbols" :key="`row-${rowIndex}`" class="your-symbols-row d-flex align-items-center justify-content-center">
                        <div v-for="(item, itemIndex) in yourSymbols[rowIndex]" :key="`item-${rowIndex}-${itemIndex}`" :class="{'symbol d-flex align-items-center justify-content-start flex-column':true, 'lucky':item.win}">
                            <span class="number">{{item.symbol}}</span>
                            <span class="amount">
                                {{item.amount}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['ticket', 'gameName'],
    data() {
        return {
            luckySymbolsArray:[]
        }
    },
    computed: {
        luckySymbols() {
            let luckies = [];

            for (const [key, symbol] of Object.entries(this.ticket.scenario.lucky_symbols)) {
                luckies.push(symbol);
            }

            return luckies;
        },

        yourSymbols() {
            let yourSymbols = {0:{}, 1:{}, 2:{}};
            let row = 0;
            let column = 0;

            for (const [key, symbol] of Object.entries(this.ticket.scenario.your_symbols)) {
                yourSymbols[row][column] = symbol;
                column++;

                if (symbol.win) {
                    this.luckySymbolsArray.push(symbol.symbol);
                }

                if (column > 4) {
                    column = 0;
                    row++;
                }
            }

            return yourSymbols;
        },
    }
}
</script>

<style>
    .fortuna_casino .lucky-symbols .symbol {
        width: 80px;
        height: 80px;
        margin-left: 10px;
        margin-right: 10px;
        border-radius: 10px;
        background: #000;
    }

    .fortuna_casino .lucky-symbols .symbol.lucky .amount {
        background: #919191;
        background: linear-gradient(to top, #000000 0%, #6E6E6E 50%, #000000 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .fortuna_casino .lucky-symbols .symbol.lucky {
        background: #ffd206;
        background-size: auto;
        border: 2px solid #f3e083;
        box-shadow: #b57f14 3px 3px 5px;
    }

    .fortuna_casino .lucky-symbols .symbol .amount {
        background: #000000;
        background: linear-gradient(to top, #110d0d 0%, #FFF 58%, #000 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .fortuna_casino .lucky-symbols .symbol .amount {
        position: absolute;
        color: #000;
        font-size: 40px;
        font-weight: bold;
        font-family: Arial;
    }

    .fortuna_casino .lucky-symbols .symbol .img-fluid {
        width: 80px;
    }

    .fortuna_casino .your-symbols .your-symbols-row {
        width: 100%;
        padding-bottom: 5px;
    }

    .fortuna_casino .your-symbols .your-symbols-row .symbol {
        width: 60px;
        position: relative;
        margin: 3px;
    }

    .fortuna_casino .your-symbols .your-symbols-row .symbol {
        font-size: 26px;
        font-family: Arial;
        font-weight:bold;
        background: #000;
        background-size: auto;
        width: 60px;
        height: 60px;
        border-radius: 10px;
    }

    .fortuna_casino .your-symbols .your-symbols-row .symbol .number {
        background: #919191;
        background: linear-gradient(to top, #110d0d 0%, #FFF 58%, #000 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .fortuna_casino .your-symbols .your-symbols-row .symbol .amount {
        color: #7965b3;
        font-size: 12px;
        font-family: Arial;
        position: absolute;
        bottom: 3px;
        font-weight: bold;
    }

    .fortuna_casino .your-symbols .your-symbols-row .symbol.lucky {
        background-size: cover;
        background: #ffd206;
        background-size: auto;
        border: 2px solid #f3e083;
        box-shadow: #b57f14 3px 3px 5px;
    }

    .fortuna_casino .your-symbols .your-symbols-row .symbol.lucky .number {
        background: #000000;
        background: linear-gradient(to top, #000000 0%, #6E6E6E 50%, #000000 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

</style>